import PropTypes from 'prop-types';

// ----------------------------------------------------------------------
PokemonList.propTypes = {
  pokemons: PropTypes.array.isRequired,
};

export default function PokemonList() {
  return console.log('sd');
}
